import type { GridCombinedList } from '@ad-lucy/components/layout/Grid/types';
import type { CreativesConfigComponents } from '@ad-lucy/config/creatives/types';

import { transformBranch } from '../../storesData/transformStores';
import type { ContentConfig, RawContentConfig } from '../types';
import { transformCategories } from './transformCategories';
import { transformComponentsAPI } from './transformComponentsAPI';

type TransformContentFunc = (
  components: Partial<CreativesConfigComponents>,
  gridList: GridCombinedList,
  data: RawContentConfig,
) => ContentConfig;

export const transformContent: TransformContentFunc = (components, gridList, data) => {
  const { transformCategoriesToPages, transformOrderedMapOfComponents, transformSearchResults } =
    transformComponentsAPI(components, gridList, data);

  return {
    branch: transformBranch(data.branch),
    categories: transformCategories(data.categories),
    general: data.general,
    footer: transformOrderedMapOfComponents(data.footer),
    header: transformOrderedMapOfComponents(data.header),
    pages: transformCategoriesToPages(data.categories),
    searchConfig: transformSearchResults(data.categories),
  };
};
